import { render, staticRenderFns } from "./ImChatPanel.vue?vue&type=template&id=519e9e7e"
import script from "./ImChatPanel.vue?vue&type=script&lang=js"
export * from "./ImChatPanel.vue?vue&type=script&lang=js"
import style0 from "./ImChatPanel.vue?vue&type=style&index=0&id=519e9e7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports